export const ROUTE_PATHS = {
  LOGIN: '/',
  CALL: 'call',
  PORTAL: '/portal',
  PORTAL_CALL: '/portal/call',
  ADMIN_DASHBOARD: '/admin',
  ADMIN_USERS: '/admin/users',
  ADMIN_KNOWLEDGE_BASE: '/admin/knowledge-base',
};
